module.exports = __webpack_public_path__ + "static/media/vahida_maam.01966363.jpg";